export default class RD3Error extends Error {
    constructor(message, title) {
        super(message);
        this.name = 'RD3 Error: ' + title;
    }
}
